//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: 'SysTypeModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '站点系统类型表单',
      tableName: 'site_sys_type',
      form_fields: ['code', 'name', 'abbreviation', 'icon', 'category', 'status', 'sort', 'remark', 'tenantId'],
      form_fields_time: [],
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        abbreviation: {
          rules: [{
            required: true,
            message: '请输入简称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入监测类型!'
          }]
        },
        icon: {
          rules: [{
            required: true,
            message: '请输入图标!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};